import type { CustomIconProps } from '../CustomIcon';

export const UserShareIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' fill={color} />
      <path
        d='M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 11h-6m0 0 2-2m-2 2 2 2M17 6h6m0 0-2 2m2-2-2-2'
        stroke={secondaryColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
        fill={color}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
